import Vue from 'vue';
import Theme from '../../../raccoonTheme';
import MessageModule from "../../mixins/MessageModule";
export default Vue.extend({
    mixins: [MessageModule],
    name: "QRLabView",
    data() {
        return {
            smallItems: [
                { icon: 'icon_dentaku.png', text: this.$t('qrlab.calculator_description'), to: '/qrlab/amount' },
                { icon: 'icon_list.png', text: this.$t('qrlab.list_description'), to: '' },
            ],
            iconBackgroundStyle: {
                background: Theme.primary,
                padding: "8px",
                height: "100%",
            }
        };
    },
    methods: {
        onTouchedCard(to) {
            if (to.length === 0) {
                this.showError(this.$t('common.coming_soon').toString());
            }
            else {
                this.$router.push(to);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/top/QRLab.vue
// module id = 390
// module chunks = 1